import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, Box, Text } from '@chakra-ui/react';
import {format} from "date-fns";

const PreviousDocumentsTable = ({ previousDocuments }) => {
    if (!previousDocuments || previousDocuments.length === 0) {
        return null;
    }

    return (
            <Table
                variant="simple"
                size="sm"
            >
                <Thead>
                    <Tr>
                        <Th>#</Th>
                        <Th>Număr document</Th>
                        <Th>Data emiterii</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {previousDocuments.map((doc, index) => (
                        <Tr key={index}>
                            <Td>{index+1}</Td>
                            <Td>{doc.series}</Td>
                            <Td>{format(new Date(doc.issueDate), "yyyy-MM-dd")}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
    );
};

export default PreviousDocumentsTable;